import { render, staticRenderFns } from "./dialogApproverStep.vue?vue&type=template&id=cf4fb85e&scoped=true&lang=pug&"
import script from "./dialogApproverStep.vue?vue&type=script&lang=js&"
export * from "./dialogApproverStep.vue?vue&type=script&lang=js&"
import style0 from "./dialogApproverStep.vue?vue&type=style&index=0&id=cf4fb85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4fb85e",
  null
  
)

export default component.exports